module.exports = __webpack_public_path__ + "assets/img/115.png?a122a90de712f1008586ee6fc613ee04";